import { isMobileDevice } from '@/utils/device'

// 主路由
const main = [
  {
    path: '/',
    redirect: '/list'
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('@/views/ErrorBoundary' /* webpackChunkName: "error" */)
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      brand: true
    },
    component: () => import('@/views/Login' /* webpackChunkName: "login" */)
  },
  {
    path: '/test',
    name: 'test',
    meta: {
      needLogin: true,
      dialogLogin: true
    },
    redirect: (to) => ({
      name: isMobileDevice() ? 'testMobile' : 'testPc',
      query: to.query,
      params: to.params
    })
  },
  {
    path: '/test/pc',
    name: 'testPc',
    meta: {
      needLogin: true,
      dialogLogin: true,
      platform: 'pc',
      platformRoutes: {
        mobile: 'testMobile',
        pc: 'testPc'
      }
    },
    component: () => import('@/views/Test' /* webpackChunkName: "test" */)
  },
  {
    path: '/test/mobile',
    name: 'testMobile',
    meta: {
      needLogin: true,
      dialogLogin: true,
      platform: 'mobile',
      platformRoutes: {
        mobile: 'testMobile',
        pc: 'testPc'
      }
    },
    component: () => import('@/views/Test' /* webpackChunkName: "test" */)
  },
  {
    path: '/pretest',
    name: 'pretest',
    meta: {
      needLogin: true
    },
    redirect: (to) => ({
      name: isMobileDevice() ? 'pretestMobile' : 'pretestPc',
      query: to.query,
      params: to.params
    })
  },
  {
    path: '/pretest/pc',
    name: 'pretestPc',
    meta: {
      needLogin: true,
      platform: 'pc',
      platformRoutes: {
        mobile: 'pretestMobile',
        pc: 'pretestPc'
      }
    },
    component: () => import('@/views/Pretest/pc' /* webpackChunkName: "pretest-pc" */)
  },
  {
    path: '/pretest/mobile',
    name: 'pretestMobile',
    meta: {
      needLogin: true,
      platform: 'mobile',
      platformRoutes: {
        mobile: 'pretestMobile',
        pc: 'pretestPc'
      }
    },
    component: () => import('@/views/Pretest/mobile' /* webpackChunkName: "pretest-mobile" */)
  },
  {
    path: '/list',
    name: 'list',
    meta: {
      needLogin: true
    },
    redirect: () => ({ name: isMobileDevice() ? 'listMobile' : 'listPc' })
  },
  {
    path: '/list/pc',
    name: 'listPc',
    meta: {
      needLogin: true,
      platform: 'pc'
    },
    component: () => import('@/views/List/pc' /* webpackChunkName: "list-pc" */)
  },
  {
    path: '/list/mobile',
    name: 'listMobile',
    meta: {
      needLogin: true,
      platform: 'mobile'
    },
    component: () => import('@/views/List/mobile' /* webpackChunkName: "list-mobile" */)
  },
  {
    path: '/touristsmsg',
    name: 'touristsmsg',
    redirect: (to) => ({
      name: isMobileDevice() ? 'touristsmsgMobile' : 'touristsmsgPc',
      query: to.query,
      params: to.params
    })
  },
  {
    path: '/touristsmsg/pc',
    name: 'touristsmsgPc',
    meta: {
      platform: 'pc',
      platformRoutes: {
        mobile: 'touristsmsgMobile',
        pc: 'touristsmsgPc'
      }
    },
    component: () => import('@/views/touristsPage' /* webpackChunkName: "tourists-pc" */)
  },
  {
    path: '/touristsmsg/mobile',
    name: 'touristsmsgMobile',
    meta: {
      platform: 'mobile',
      platformRoutes: {
        mobile: 'touristsmsgMobile',
        pc: 'touristsmsgPc'
      }
    },
    component: () => import('@/views/touristsPage/mobile' /* webpackChunkName: "tourists-mobile" */)
  },
  {
    path: '/thirdLogin',
    name: 'thirdLogin',
    component: () =>
      import('@/views/Login/ThirdLogin' /* webpackChunkName: "thirdLogin" */),
    meta: {
      layout: 'Noop'
    }
  },
  {
    path: '/showPaper',
    name: 'showPaper',
    // meta: {
    //   needLogin: true
    // },
    component: () => import('@/views/ExamineePaperView' /* webpackChunkName: "showPaper" */)
  },
  {
    path: '/jumpPage',
    name: 'jumpPage',
    component: () => import('@/views/jumpPage' /* webpackChunkName: "jumpPage" */)
  },
  {
    path: '/detect',
    name: 'detect',
    component: () => import('@/views/Detect' /* webpackChunkName: "detect" */),
    meta: {
      needLogin: true,
      layout: 'Noop'
    }
  },
  {
    path: '/identityCheck',
    name: 'identityCheck',
    component: () => import('@/views/IdentityCheck' /* webpackChunkName: "IdentityCheck" */),
    meta: {
      needLogin: true,
      layout: 'Noop'
    }
  }
]

export default main
